<template>
  <footer class="footer" role="contentinfo" aria-labelledby="footer-title">
    <h2 id="footer-title" class="sr-only">Informazioni su Atlante delle Professioni</h2>
    <div class="footer-content">
      <div class="logos-container">
        <div class="logos">
          <a href="/" class="logo-link" aria-label="Homepage Atlante delle Professioni">
            <img style="padding-right: 8px" src="@/assets/logo-atlante-white.svg"
              alt="Logo Atlante delle Professioni" class="logo" />
          </a>
          <a href="https://www.unito.it/" target="_blank" rel="noopener" class="logo-link"
            aria-label="Sito dell'Università degli Studi di Torino (si apre in una nuova finestra)">
            <img src="@/assets/logo-unito.png" alt="Logo Università di Torino" class="logo" />
          </a>
          <a href="https://www.dcps.unito.it/do/home.pl" target="_blank" rel="noopener" class="logo-link"
            aria-label="Sito del Dipartimento di Culture, Politica e Società (si apre in una nuova finestra)">
            <img src="@/assets/logo-cps.png" alt="Logo CPS" class="logo" />
          </a>
          <a href="https://www.dcps.unito.it/do/home.pl/View?doc=osservatorio_professioni.html" target="_blank"
            rel="noopener" class="logo-link"
            aria-label="Sito dell'Osservatorio Professioni (si apre in una nuova finestra)">
            <img src="@/assets/logo-osservatorio.png" alt="Logo Osservatorio" class="logo" />
          </a>
        </div>
        <p class="footer-description">L'Atlante ti aiuta a navigare tra le professioni, i luoghi di lavoro, i titoli di
          studio e le competenze attraverso video, schede e statistiche per orientarti nel mercato del lavoro.</p>
      </div>

      <div class="bottom-content">
        <div class="footer-links">
          <a href="https://form.agid.gov.it/view/de4a5490-4114-11f0-8e79-178ec40b0467" target="_blank" class="link"
            aria-label="Dichiarazione di accessibilità (si apre in una nuova finestra)">
            Dichiarazione di accessibilità
          </a>
          <p>&copy; 2012-2026 Università degli Studi di Torino, progetto Atlante delle Professioni</p>
        </div>
        <div class="footer-bottom-row">
                  <div class="footer-links">
          <a href="/contatti" class="link">CONTATTI</a> / <a href="https://www.unito.it/privacy" target="_blank"
            rel="noopener" class="link" aria-label="Privacy Policy (si apre in una nuova finestra)">PRIVACY POLICY</a>
        </div>
        <div class="social-media">
          <a href="https://www.facebook.com/AtlantedelleProfessioni" target="_blank" rel="noopener" class="social-link"
            aria-label="Pagina Facebook dell'Atlante delle Professioni (si apre in una nuova finestra)">
            <img src="@/assets/fb_icon.svg" alt="Facebook" />
          </a>
        </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
};
</script>

<style scoped>
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.footer {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: rgba(1, 55, 71, 1);
  color: #fff;
  width: 100%;
  padding: 1rem;
  padding-top: 35px;
  text-align: center;
  z-index: 10;
  box-sizing: border-box;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
  margin-bottom: 50px;
}

.logos-container {
  display: flex;
  width: 100%;
  max-width: 1138px;
  flex-direction: column;
  align-items: flex-start;
  gap: 22px;
  margin-top: 60px;
}

.footer-description {
  width: 40%;
  color: #DEDDD6;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.3px;
}

.logos {
  display: flex;
  flex-direction: row;
  gap: 15px;
}

.logo-link .logo {
  height: 120px;
  margin-bottom: 1rem;
}

/* Add focus styles for better keyboard accessibility */
.logo-link:focus,
.footer-links .link:focus,
.social-link:focus {
  outline: 3px solid #3BFF3B;
  outline-offset: 3px;
}

.footer-links .link {
  color: #fff;
  margin: 0 5px;
  text-decoration: none;
  font-weight: normal;
}

.social-media .social-link img {
  height: 40px;
  /* Adjusted for consistency */
}

.footer-bottom-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  margin-left: auto;
}

.bottom-content {
  display: flex;
  flex-direction: row;
  gap: 120px;
  align-items: center;
  margin-top: 90px;
  width: 100%;
  max-width: 1138px;
}

.bottom-content p {
  color: #DEDDD6;
  font-size: 12px;
  line-height: 19px;
  letter-spacing: 0.3px;
}

.footer-links a {
  font-family: "Montserrat", sans-serif;
  color: hsl(0deg, 0%, 100%);
  font-size: 11px;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-weight: normal;
}

@media (max-width: 992px) {
  .footer {
    padding: 20px;
    width: auto;
  }

  .footer-description {
    width: 80%;
  }

  .bottom-content {
    flex-direction: column;
    gap: 15px;
  }

  .bottom-content {
    align-items: flex-start;
  }

  .social-media {
    margin-left: 10px;
  }

  .footer-bottom-row{
    margin-left: 0;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .logo-link .logo {
    height: 60px;
  }

  .social-media {
    margin-top: 1rem;
  }
}

@media (max-width: 600px) {
  .logo-link .logo {
    height: 60px;
  }
}
</style>